import { GetStaticProps } from 'next';
import React, { useEffect } from 'react';
import EducationLoan from '../../components/EduationLoan';
import { MetaTagsComp } from '../../components/MetaTagsComp';
import fetchUtil from '../../utils/fetchUtil';
import { CACHE_REVALIDATE_24H } from '../../utils/constants';


const EducaLoan: React.FC = (props: any) => {
  const { meta } = props.pageData
  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--navbar-color', '#6C48F0');
    customStyle.setProperty('--navbar-menu-color', '#ffff')
  }, [])
  return (
    <>
      {meta && <MetaTagsComp {...meta} />}
      <EducationLoan {...props} />
    </>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/education-loans`, 'GET', {}, '', false)
  return {
    props: { pageData },
    revalidate: CACHE_REVALIDATE_24H,

  };
}

export default EducaLoan;